import { render, staticRenderFns } from "./UserProfileItem.vue?vue&type=template&id=ea3b6516&scoped=true"
import script from "./UserProfileItem.vue?vue&type=script&lang=js"
export * from "./UserProfileItem.vue?vue&type=script&lang=js"
import style0 from "./UserProfileItem.vue?vue&type=style&index=0&id=ea3b6516&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea3b6516",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VImg})
